import React, {Component} from 'react';
import {Toast} from 'antd-mobile';
import OrderShunt from '../../../../../../components/OrderShunt';
import {connect} from "react-redux";

@connect(
    state => ({userInfo: state.userInfo}),
)
export default class Now extends Component {
    constructor(props) {
        super(props);
        this.state = {
            totalData: {},
            dataList: [],
            type:1,//0是出发，1是到达
            // description: '明细表只能下载24小时以前的统计',
        };
    }

    componentDidMount() {
        // Toast.loading('正在加载', 0);
        // let params = {
        //     token: this.props.userInfo.token,
        //     "data": {
        //         "billType":1,
        //         "operatorType":1,
        //     }
        // };
        // getbillofdriver(params).then((res) => {
        //     console.log(res)
        //     Toast.hide();
        //     if (res.data.code === '0000') {
        //
        //         this.setState({
        //             totalData: res.data.data,
        //
        //         });
        //     }
        // }).catch(function (error) {
        //     console.log(error);
        // });
    }
    goPage = (k) =>{
        this.props.history.push(k)
    }
    render() {
        return (
            <OrderShunt 
                goPage={this.goPage.bind(this)}
                {...this.state}
                {...this.props}
            />
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Home/changeRole/Shunt/shuntOrder/endShunt/index.js